import { createContext, useContext, useState } from "react";


const ToggleContext = createContext();


export const ToggleProvider = ({ children }) => {
  const [isActive, setIsActive] = useState(false)

  const toggleClose = () => {
    setIsActive((prev) => false)
}


  const toggleBTN = () => {
    setIsActive(!isActive)
  }

//console.log('isActive context: ', isActive)

  return (
    <ToggleContext.Provider value={{ isActive, toggleClose, toggleBTN }}>
      {children}
    </ToggleContext.Provider>
  );
};


export const useToggle = () => useContext(ToggleContext)
